module.exports = __webpack_public_path__ + "img/advance-payment-setup.145d613.svg";